export default "__VITE_ASSET__DwJisstR__"